// extracted by mini-css-extract-plugin
module.exports = {"image":"CardInitialsImage_image__O03U8"};